import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import plus from '../dist/webImages/plus.png'
import role from '../dist/webImages/role.png'
import useDelete from '../customHooks/useDelete'
import swal from 'sweetalert';
import useGet from '../customHooks/useGet';
import { MainLanguageContext } from '../context/MainLanguageContext';
import { toast } from 'react-toastify';
import SkeletonRoleList from './SkeletonRoleList';
import { FaUserTie } from "react-icons/fa";


const RoleList = () => {
    const { mainLanguage } = useContext(MainLanguageContext);
    const [datas, setDatas] = useState()
    const [resget, apiMethodGet] = useGet()

    useEffect(() => {
        if (mainLanguage) {
            apiMethodGet(`roles`);
        }
    }, [mainLanguage]);
    useEffect(() => {
        if (!resget.isLoading) {
            setDatas(resget?.data?.data)
        }

    }, [resget.data])


    const [resDelete, apiMethodDelete] = useDelete();
    const [delateId, setDelateId] = useState("")
    const handleDelete = (id) => {
        setDelateId(id)
        swal({
            title: "Are you sure?",
            text: "Are you sure that you want to delete?",
            buttons: true,
            icon: "warning",
            dangerMode: true,
        })
            .then(willDelete => {
                if (willDelete) {
                    apiMethodDelete(`roles/remove/${id}`)

                }

            });
    }
    useEffect(() => {
        if (resDelete.data) {
            const { status, message } = resDelete?.data
            if (status === false) {
                toast.error(message);
            }
            else {
                swal("Successfully Delete", "", "success");
                const update = datas.filter((item) => item.id !== delateId)
                setDatas(update)
                toast.success(message);
            }
        }

    }, [resDelete.data])


    if (resget.isLoading) return <SkeletonRoleList />
    return (
        <div className='services'>
            <div className="servicesTop flex justify-end items-center mb-4">
                {/* <h6 className='text-[1rem] mb-2 bookingSectionh relative px-3 font-Mluvka'> Role</h6> */}
                <Link to={"/role/create"} className='bg-[#A38560]/50 py-2 px-4 rounded-full flex items-center gap-2 cursor-pointer' >
                    <img src={plus} alt="plus" className="w-6" />
                    <span className='font-MluvkaBold text-secondary capitalize text-[.9rem]'>Add Role</span>
                </Link>
            </div>
            <div className="servicesBottom rounded-[10px] grid grid-cols-6 gap-4 max-lg:grid-cols-1">
                {
                    Array.isArray(datas) && datas.map((item) => {
                        const { name, id } = item
                        return (
                            <div className=' border-2 bg-white border-[#ddd] py-3 px-2 rounded-[10px] relative' key={id}>
                                {/* <img src={role} className='mx-auto w-[3rem] h-[3rem] ' alt="" /> */}
                                <FaUserTie className='mx-auto w-[3rem] h-[3rem] text-secondary' />
                                <div className="servicesCard__Body">
                                    <div className="h4 font-Cinzel text-[1.2rem] leading-[1] text-center mt-1 text-secondary">{name}</div>
                                </div>
                                <div className="mt-2">
                                    <div className='closeButton cursor-pointer absolute bg-[#FFCEDA] w-[1.5rem] h-[1.5rem] p-[.5rem] top-[.7rem] right-[.7rem] grid place-items-center rounded-full z-10' onClick={() => handleDelete(id)}>
                                        <svg className='w-full h-full' width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.8612 1.34766L0.951172 16.2567M15.8612 16.2577L0.951172 1.34863" stroke="#ED2656" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                    {/* <div className='closeButton cursor-pointer font-semibold bg-[#A38560]/50 text-secondary text-[.9rem] grid place-items-center rounded-[.7rem] z-10' onClick={() => handleDelete(id)}>
                                        Delete
                                    </div> */}
                                    <Link to={`/role/edit/${id}`} className="servicesCard text-secondary text-[.8rem] w-fit px-2 mx-auto relative bg-[#A38560]/50 grid place-items-center rounded-[.7rem] z-10" >
                                        Edit
                                    </Link>
                                </div>
                            </div>)


                    })
                }

            </div>
        </div>
    )
}

export default RoleList